import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/common/ErrorBoundary';

// Suppress AbortError from fetch/React Query cancellation before any React code runs,
// so the CRA runtime error overlay does not show these benign cancellations.
const isAbortError = (err: unknown) =>
  (err instanceof DOMException && err.name === 'AbortError') ||
  (err && typeof err === 'object' && (err as { name?: string }).name === 'AbortError') ||
  (err && typeof err === 'object' && String((err as { message?: string }).message || '').includes('signal is aborted'));
window.addEventListener('error', (e) => {
  if (isAbortError(e.error)) {
    e.preventDefault();
    e.stopPropagation();
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  if (isAbortError(e.reason)) {
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
